import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '@environment/environment';

export const apiRequestInterceptor: HttpInterceptorFn = (req, next) => {

  if (req.url.startsWith('http') || req.url.startsWith('/')) {
    return next(req);
  }

  const apiRequest = req.clone({
    url: `${ environment.apiHost }/api/${ req.url }`,
  });

  return next(apiRequest);
};
